module.exports = __webpack_public_path__ + "img/employee-disabled.a52ccb3f.svg";